/* eslint-disable import/no-cycle */
import { v4 as uuidv4 } from 'uuid';
import { Branch, QUESTIONNAIRE_ELEMENT_TYPE, SCREENING_TYPE } from '../../questionnaireTemplate.enums';
import { MultiChoiceOption, QuestionnaireFormElement } from '../../questionnaireTemplate.types';
import { ValidationOperator } from '../builderElements/formElements/questionValidationRules/questionValidationRules.types';
import { formElementSchema } from '../schemas/formElement.schema';

const createDefaultOption = (): MultiChoiceOption => ({
  id: uuidv4(),
  text: '',
});

export const createNewSchema = (
  type: QUESTIONNAIRE_ELEMENT_TYPE,
  parentId: string | null = null,
  parentBranch: Branch | null = null,
) => {
  const newId = uuidv4();
  const schema = formElementSchema[type];
  const newElement: QuestionnaireFormElement = {
    id: newId,
    questionType: type,
    label: schema.label,
    parentId,
    parentBranch,
    question: '',
    config: {},
    expanded: true,
    screeningType: SCREENING_TYPE.NONE,
    shouldReaskOnReapply: false,
  };
  if (type === QUESTIONNAIRE_ELEMENT_TYPE.FREE_FORM) {
    // eslint-disable-next-line
    // newElement.maxLength = MAX_LENGTH_OPTIONS[3];
    newElement.maxLength = 500;
  }
  if (type === QUESTIONNAIRE_ELEMENT_TYPE.MULTI_CHOICE || type === QUESTIONNAIRE_ELEMENT_TYPE.MULTI_CHOICE_WITH_IMAGE) {
    newElement.options = [createDefaultOption(), createDefaultOption()];
    newElement.correctAnswerIf = ValidationOperator.IS_EQUAL;
    newElement.totalAnswer = 1;
  }

  if (type === QUESTIONNAIRE_ELEMENT_TYPE.YESNO || type === QUESTIONNAIRE_ELEMENT_TYPE.YESNO_WITH_IMAGE) {
    newElement.preferredAnswer = schema?.branches?.[0] as Branch;
  }
  if (type === QUESTIONNAIRE_ELEMENT_TYPE.VIDEO_RESPONSE) {
    newElement.maximumVideoDuration = 1;
    newElement.isSkippable = false;
  }
  if (type === QUESTIONNAIRE_ELEMENT_TYPE.DOCUMENT_UPLOAD) {
    newElement.maximumDocumentCount = 1;
    newElement.isSkippable = false;
  }
  return newElement;
};
